var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags-view component"},_vm._l((_vm.tags),function(tag){return _c('div',{key:tag.id,staticClass:"tag"},[_c('router-link',{attrs:{"to":{ name: 'tag', params: { name: tag.name }}}},[_vm._v(_vm._s(tag.label)),_c('span',{staticClass:"comma"},[_vm._v(",")])])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22a86835","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagsView.vue
// module id = null
// module chunks = 